import React from "react";
import { BsFillCaretUpFill, BsFillCaretDownFill } from "react-icons/bs";
import { FaPlus, FaCartPlus, FaTrashAlt, FaPencilAlt } from "react-icons/fa";
import $ from "jquery";
import EditStock from "./EditStock";
import AddStock from "./AddStock";

$('[data-toggle="tooltip"]').tooltip();

export default function CurrentStocks({
  getEditedStock,
  getAddedStock,
  list,
  deleteStock,
  deleteSoldStock,
  handleGetStock,
  removeSoldValidation,
  buyNewQnty,
  buyNewPrice,
}) {
  const addStockRemoveValidation = () => {
    buyNewQnty.current.value = "";
    buyNewPrice.current.value = "";
    document.getElementById("AddStockqtyMessage").classList.add("d-none");
    document
      .getElementById("AddStockqtyInput")
      .classList.remove("border", "border-danger");
    document.getElementById("AddStockPriceMessage").classList.add("d-none");
    document
      .getElementById("AddStockPrice")
      .classList.remove("border", "border-danger");
    document.getElementById("addTitle").innerHTML = `(${list.company})`;
  };
  const editStockRemoveValidation = () => {
    document.getElementById("nodateEdit").classList.add("d-none");
    document
      .getElementById("nodateInputEdit")
      .classList.remove("border", "border-danger");
    document.querySelectorAll("#nonumber")[0].classList.add("d-none");
    document
      .querySelectorAll("#dropdownMenu")[0]
      .classList.remove("border", "border-danger");
    document.getElementById("noqntyEdit").classList.add("d-none");
    document
      .getElementById("buyQntyInputEdit")
      .classList.remove("border", "border-danger");
    document.getElementById("nopriceEdit").classList.add("d-none");
    document
      .getElementById("buypriceInputEdit")
      .classList.remove("border", "border-danger");
  };
  return (
    <>
      {!list.completed && (
        <tr key={list.id} className="">
          <td style={{ width: "20%" }}>{list.company}</td>
          <td>{list.date}</td>
          <td>{list.quantity}</td>
          <td>{(+list.price).toFixed(2)}</td>
          <td>{list.totalFees.toFixed(2)}</td>
          <td>{(+list.price + list.totalFees / list.quantity).toFixed(2)}</td>
          <td>{list.total.toFixed(2)}</td>
          <td className="text-primary ">
            <span data-toggle="modal" data-target="#sellingModal">
              <button
                className="btn-outline-danger btn btn-sm mr-2 mb-1"
                data-toggle="tooltip"
                data-placement="top"
                title="بيع اسهم"
                onClick={() => {
                  handleGetStock(list.id);
                  removeSoldValidation();
                  $("button").tooltip("hide");
                }}
              >
                <FaCartPlus size="1.4em" />
              </button>
            </span>
            <span
              data-toggle="modal"
              data-target={list.sold.length > 0 ? "" : "#editStock"}
            >
              <button
                className="btn-outline-primary btn btn-sm mr-2 mb-1"
                disabled={list.sold.length > 0 ? true : false}
                data-toggle="tooltip"
                data-placement="top"
                tabIndex="0"
                data-original-title={
                  list.sold.length > 0
                    ? "لايمكن تعديل سهم يحتوي على اسهم مباعة"
                    : "تعديل"
                }
                onClick={() => {
                  getEditedStock(list.id);
                  editStockRemoveValidation();
                  $("button").tooltip("hide");
                }}
              >
                <FaPencilAlt size="1.4em" />
              </button>
            </span>
            <EditStock />
            <span
              data-toggle="modal"
              data-target={list.sold.length > 0 ? "" : "#addStock"}
            >
              <button
                className="btn-outline-primary btn btn-sm mr-2 mb-1"
                data-toggle="tooltip"
                data-placement="top"
                disabled={list.sold.length > 0 ? true : false}
                data-original-title={
                  list.sold.length > 0
                    ? "لايمكن الاضافة لسهم يحتوي على اسهم مباعة"
                    : "اضافة اسهم"
                }
                onClick={() => {
                  getAddedStock(list.id);
                  addStockRemoveValidation();
                  $("button").tooltip("hide");
                }}
              >
                <FaPlus size="1.4em" />
              </button>
            </span>
            <AddStock />
            <button
              type="button"
              className=" btn btn-sm btn-outline-danger mr-2 mb-1"
              data-toggle="tooltip"
              data-placement="top"
              title="حذف"
              onClick={() => {
                $("button").tooltip("hide");
                deleteStock(list.id);
              }}
            >
              <FaTrashAlt size="1.4em" />
            </button>
          </td>
        </tr>
      )}
      {list.sold.length > 0 && !list.completed && (
        <tr className="text-center table-light">
          {/* <td ></td>
          <th scope="col">تاريخ البيع</th>
          <th scope="col">الكمية</th>
          <th scope="col">سعر البيع</th>
          <th scope="col">العمولات</th>
          <th scope="col">الربح / الخسارة</th>
          <th scope="col">الاجمالي</th>
          <th scope="col"></th> */}
          <td></td>
          <td>تاريخ البيع</td>
          <td>الكمية</td>
          <td>سعر البيع</td>
          <td>العمولات</td>
          <td>الربح / الخسارة</td>
          <td>الصافي</td>
          <td></td>
        </tr>
      )}
      {list.sold.length > 0 && !list.completed && (
        <>
          {list.sold.map((sold) => {
            return (
              <tr key={sold.id} className="table-light">
                <td></td>
                <td>{sold.date}</td>
                <td>{sold.quantity}</td>
                <td>{sold.soldPrice}</td>
                <td>{sold.totalFees.toFixed(2)}</td>
                <td
                  className={
                    (sold.profit > 0 && " text-success") ||
                    (sold.profit < 0 && "text-danger")
                  }
                >
                  {sold.profit.toFixed(2)}{" "}
                  {(sold.profit > 0 && <BsFillCaretUpFill />) ||
                    (sold.profit <= 0 && <BsFillCaretDownFill />)}{" "}
                  {sold.percentage.toFixed(2)}
                  &rlm;{"%"}
                </td>
                <td>{sold.total.toFixed(2)}</td>
                <td className="text-primary ">
                  <button
                    className=" btn btn-sm btn-outline-danger mr-2"
                    onClick={() => deleteSoldStock(list.id, sold.id)}
                  >
                    <FaTrashAlt size="1.4em" />
                  </button>
                </td>
              </tr>
            );
          })}
        </>
      )}
    </>
  );
}
